import { render } from "./TypeItem.vue?vue&type=template&id=c57f8a7a&scoped=true"
import script from "./TypeItem.vue?vue&type=script&lang=js"
export * from "./TypeItem.vue?vue&type=script&lang=js"

import "./TypeItem.vue?vue&type=style&index=0&id=c57f8a7a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57f8a7a"]])

export default __exports__